import React, { Component, PropTypes } from 'react';

export default class TabletHTML extends Component {
	constructor (props) {
		super(props);
		this.state = {
			value: this.props.value,
		};
	}

	// onChange = value => {
	// 	this.setState({ value });
	// 	if (this.props.onChange) {
	// 		// Send the changes up to the parent component as an HTML string.
	// 		// This is here to demonstrate using `.toString()` but in a real app it
	// 		// would be better to avoid generating a string on each change.
	// 		this.props.onChange(value.toString('html'));
	// 	}
	// };

	onChange(y, x, newval) {
		const { value } = this.state;
		value[y][x] = newval;
		this.setState({ value });
		this.props.onChange(value);
	}

	prepareRows() {
		const { value } = this.state;
		const rows = value.map((row, y) => {

			const cells = row.map((cell, x) => {
				return (
					<input autoComplete="off"
						key={`cell-${y}-${x}`}
	          className="inp__field"
	          type="text"
	          value={cell}
	          onChange={e => this.onChange(y, x, e.target.value)}
	        />
				)
			})

			return (
				<div key={`row-${y}`} className="table-editor__row">
					<button onClick={() => this.delRow(y)} className="table-editor__del-row">-</button>
					{cells}
				</div>
			)
		});

		return rows;
	}

	prepareDelColumns() {
		const { value } = this.state;
		const cells = value[0].map((cell, x) => {
			return (
				<div key={`del-column-${x}`} className="table-editor__del-wrapper">
					<button onClick={() => this.delColumn(x)} className="table-editor__del-column">-</button>
				</div>
			)
		})

		return (
			<div className="table-editor__row">
				{cells}
			</div>
		)
	}

	delColumn(x) {
		const { value } = this.state;
		if (value[0].length > 2) {
			const newValue = value.map(row => {
				const cells = row;
				cells.splice(x,1);
				return cells;
			});
			this.setState({ value });
		} else {
			alert("В таблице должно быть хотя бы два столбца");
		}
	}

	delRow(y) {
		const { value } = this.state;
		if (value.length > 2) {
			value.splice(y,1);
			this.setState({ value });
		} else {
			alert("В таблице должно быть хотя бы две строки");
		}
	}

	addColumn() {
		const { value } = this.state;
		if (value[0].length < 6) {
			const newValue = value.map(row => {
				return row.concat([''])
			});
			this.setState({
				value: newValue
			})
		} else {
			alert("В таблице возможно максимум 6 столбцов")
		}
	}

	addRow() {
		const { value } = this.state;
		if (value.length < 50) {
			const newRow = value[0].map(row => {
				return ''
			});
			value.push(newRow);
			this.setState({
				value
			})
		} else {
			alert('В таблице возможно максимум 50 строк')
		}
	}

	render() {
		const { value } = this.state;
		return (
			<div className="table-editor">
				<button onClick={() => this.addColumn() }className="table-editor__add-column">+</button>
				{this.prepareDelColumns()}
				{this.prepareRows()}
				<button onClick={() => this.addRow() } className="table-editor__add-row">+</button>
			</div>
		);
	}
}
